import categoryIcons from '@range.io/functional/src/categories/category-icons.js'
import React, { useMemo, useState } from 'react'
import { styled } from '../../range-theme/index.js'
import IconPickerGrid from './IconPickerGrid.jsx'
import IconPickerSearchBar from './IconPickerSearchBar.jsx'

// Mapping from icon names to human-readable labels
const iconLabels = {
    // Fire safety icons
    fdc: 'FDC (Fire Department Connection)',
    fireBell: 'Fire Bell',
    fireExtinguisher: 'Fire Extinguisher',
    fireHornStrobe: 'Fire Horn/Strobe',
    fireHose: 'Fire Hose',
    firePanel: 'Fire Panel',
    firePanelAnnunciator: 'Fire Panel Annunciator',
    fireSprinkler: 'Fire Sprinkler',
    hydrant: 'Fire Hydrant',
    osyValve: 'OS&Y (Outside Screw & Yoke Valve)',
    pivValve: 'PIV (Post Indicator Valve)',
    pullStation: 'Fire Pull Station',
    riser: 'Riser',

    // Common icons with better labels
    airconditioning: 'Air Conditioning',
    beam: 'Structural Beam',
    concrete: 'Concrete',
    doors: 'Doors',
    rock: 'Rock/Stone',
}

// Helper function to convert camelCase to Title Case as fallback
const camelCaseToTitleCase = str =>
    str
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, match => match.toUpperCase())
        .trim()

// Helper function to get human-readable label
const getIconLabel = name => iconLabels[name] || camelCaseToTitleCase(name)

// convert category-icons data to [{ name: String, icon: SvgText, label: String }]
const asWrapper = ([name, svgText]) => ({ name, icon: svgText.trim(), label: getIconLabel(name) })

const iconList = Object.entries(categoryIcons).map(asWrapper)
iconList.sort((a, b) => a.name.localeCompare(b.name))

const StyledContainer = styled('div', {
    width: '410px',
    height: '416px',
    padding: '16px 16px 0px 16px',
    background: '$neutral10',
    borderRadius: 10,
    border: '1px solid $neutral07',
    display: 'flex',
    flexDirection: 'column',
})

const IconPicker = ({ selectedIcon, onSelectedIconChange }) => {
    const [search, setSearch] = useState('')

    const filteredIcons = useMemo(() => {
        const searchTerm = search.toLowerCase()
        return iconList.filter(
            ({ name, label }) => name.toLowerCase().includes(searchTerm) || label.toLowerCase().includes(searchTerm)
        )
    }, [search])

    return (
        <StyledContainer>
            <IconPickerSearchBar value={search} onChange={setSearch} />
            <IconPickerGrid icons={filteredIcons} selectedIcon={selectedIcon} onSelectIcon={onSelectedIconChange} />
        </StyledContainer>
    )
}

export default IconPicker
